import React from 'react';
import { cn } from '@utils/cn';

interface StatsCardProps {
  /** Icon node (typically a Material UI icon) */
  icon: React.ReactNode;
  /** Numeric or string value displayed prominently */
  value: number | string;
  /** Caption shown under the value */
  label: string;
  /** Optional click handler — turns the card into a button */
  onClick?: () => void;
  /** Extra classes for the outer container */
  className?: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  icon,
  value,
  label,
  onClick,
  className,
}) => {
  const baseClasses =
    'bg-white rounded-lg shadow-sm ring-1 ring-gray-900/5 p-4 flex items-center gap-3';

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(
          baseClasses,
          'text-left transition-shadow hover:shadow-md',
          className,
        )}
      >
        {icon}
        <div>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          <p className="text-xs text-gray-500">{label}</p>
        </div>
      </button>
    );
  }

  return (
    <div className={cn(baseClasses, className)}>
      {icon}
      <div>
        <p className="text-2xl font-bold text-gray-900">{value}</p>
        <p className="text-xs text-gray-500">{label}</p>
      </div>
    </div>
  );
};

export default StatsCard;
